import { Button } from "primereact/button";

import { Checkbox, EmptyState, ForbiddenState, Icon, LoadingState, StateMessage } from "@/ds";
import { AplicarReferenciaObrasDialog } from "@/shared/components";
import { DistribuicaoArvore } from "./distribuicao-arvore";
import { DistribuicaoDialog } from "./distribuicao-dialog";
import { SituacaoDistribuicaoDialog } from "./situacao-distribuicao-dialog";
import {
  DISTRIBUICOES_DESCRICAO,
  DISTRIBUICOES_ERROR_MESSAGE,
  DISTRIBUICOES_FORBIDDEN_MESSAGE,
  DISTRIBUICOES_LOADING_LABEL,
  DISTRIBUICOES_MOSTRAR_INATIVAS_LABEL,
  DISTRIBUICOES_NOVA_LABEL,
  DISTRIBUICOES_TENTAR_DE_NOVO,
  DISTRIBUICOES_TITULO,
  DISTRIBUICOES_VAZIO_DESCRICAO,
  DISTRIBUICOES_VAZIO_TITULO,
} from "./distribuicoes.constants";
import styles from "./distribuicoes.module.scss";
import type { DistribuicoesViewModel } from "./types-distribuicoes";

const INATIVAS_INPUT_ID = "distribuicoes-mostrar-inativas";

export function DistribuicoesView({
  conteudo,
  erro,
  mostrarInativas,
  alternarInativas,
  nos,
  recarregar,
  nova,
  dialogo,
  situacaoDialogo,
  aplicacaoDialogo,
  mobile,
}: DistribuicoesViewModel) {
  return (
    <section
      className={mobile ? `${styles.tela} ${styles.telaMobile}` : styles.tela}
      aria-label={DISTRIBUICOES_TITULO}
      data-testid="financeiro-distribuicoes-screen"
    >
      <div className={styles.barra}>
        <div className={styles.filtro}>
          <Checkbox
            inputId={INATIVAS_INPUT_ID}
            checked={mostrarInativas}
            onChange={alternarInativas}
            data-testid="distribuicoes-mostrar-inativas"
          />
          <label htmlFor={INATIVAS_INPUT_ID}>{DISTRIBUICOES_MOSTRAR_INATIVAS_LABEL}</label>
        </div>
        {nova ? (
          <Button
            type="button"
            className={styles.nova}
            icon={<Icon name="plus" size={14} />}
            label={DISTRIBUICOES_NOVA_LABEL}
            onClick={nova}
            data-testid="distribuicoes-nova"
          />
        ) : null}
      </div>

      <header className={styles.secao}>
        <h2 className={styles.titulo}>{DISTRIBUICOES_TITULO}</h2>
        <p className={styles.descricao}>{DISTRIBUICOES_DESCRICAO}</p>
      </header>

      {conteudo === "carregando" ? (
        <LoadingState label={DISTRIBUICOES_LOADING_LABEL} testId="distribuicoes-loading" />
      ) : null}
      {conteudo === "sem-permissao" ? (
        <ForbiddenState
          description={DISTRIBUICOES_FORBIDDEN_MESSAGE}
          testId="distribuicoes-sem-permissao"
        />
      ) : null}
      {conteudo === "erro" ? (
        <StateMessage
          variant="error"
          title={erro ?? DISTRIBUICOES_ERROR_MESSAGE}
          action={{ label: DISTRIBUICOES_TENTAR_DE_NOVO, onClick: recarregar, icon: "refresh" }}
          testId="distribuicoes-erro"
        />
      ) : null}
      {conteudo === "vazio" ? (
        <EmptyState.Root size="sm" testId="distribuicoes-vazio">
          <EmptyState.Illustration name="sem-dados" />
          <EmptyState.Title>{DISTRIBUICOES_VAZIO_TITULO}</EmptyState.Title>
          <EmptyState.Description>{DISTRIBUICOES_VAZIO_DESCRICAO}</EmptyState.Description>
          {nova ? (
            <EmptyState.Action
              label={DISTRIBUICOES_NOVA_LABEL}
              icon="plus"
              onClick={nova}
              data-testid="distribuicoes-vazio-nova"
            />
          ) : null}
        </EmptyState.Root>
      ) : null}
      {conteudo === "arvore" ? <DistribuicaoArvore nos={nos} mobile={mobile} /> : null}
      {dialogo ? <DistribuicaoDialog {...dialogo} /> : null}
      {situacaoDialogo ? <SituacaoDistribuicaoDialog {...situacaoDialogo} /> : null}
      {aplicacaoDialogo ? <AplicarReferenciaObrasDialog {...aplicacaoDialogo} /> : null}
    </section>
  );
}
